import BotoesSalvarExcluir from '@/shared/components/forms/BotoesSalvarExcluir';
import Links from '@/shared/constants/navegacao';
import Loading from '@/shared/components/Carregando';
import ModalExcluir from '@/shared/components/modals/ModalExcluir';
import ModalHistorico from '@/modules/system/historico/ModalHistorico';
import Select from 'react-select';
import TabelaRegistros from '../components/tabelaregistros';
import { CACHE_MOVIMENTOS } from '@/shared/constants/strings';
import { DataAmigavel, DataIso, NormalizarData, TempoAmigavelAteHoje } from '@/shared/utils/datas';
import { EditadoPorRodape } from '@/shared/components/EditadoPorRodape';
import { Form } from 'react-bootstrap';
import { Fragment } from 'react/jsx-runtime';
import { GetDefensorias } from '@/modules/structure/defensoria/defensoria.service';
import { GetNucleos } from '@/modules/structure/nucleo/nucleo.service';
import { LerMovimentacao, ExcluirMovimentacao, AtualizarMovimentacao } from '../movimentacao.service';
import { MovimentacaoRegistrosDto, ReadDefensoriaDto, ReadNucleoDto, MovimentacaoReferenceDto, ReadDistritoDto, ReadMovimentacaoDto, UpdateMovimentacaoDto } from '@/api.types';
import { ReadDefensor } from '@/modules/people/defensor.service';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Tabelas } from '@/shared/constants/tables';
import { readDistrito } from '@/modules/structure/distrito/distrito.service';
import { toast } from 'react-toastify';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { useEffect, useState } from 'react';
import { useParams, useNavigate, useSearchParams, } from 'react-router-dom';

interface IOpcao {
  value: number;
  label: string;
}

type MovimentacaoReferenceDtoExtended = MovimentacaoReferenceDto & {
  data_admissao?: Date | string;
  data_nascimento?: Date | string;
};

export default function MovimentacaoEditar() {
  const { register, handleSubmit, reset, getValues, setValue, watch } = useForm<ReadMovimentacaoDto>();
  const { setActions } = useBreadcrumbActions();
  const subscription = watch();
  const navigate = useNavigate();

  useEffect(() => {
    const defensorId = subscription?.defensor?.id;
    const ref = subscription?.referencia;
    const href = defensorId && ref
      ? `${Links.Movimentacoes_Criar}/${defensorId}/${DataIso(ref, 'yyyy-MM')}`
      : Links.Movimentacoes_Criar;
    setActions({
      secondary: { label: 'Novo', href, onClick: () => { } },
      history: { label: 'Histórico', onClick: () => setModalHistorico(true) },
    });
    return () => setActions({});
  }, [setActions, subscription?.defensor?.id, subscription?.referencia]);

  // Parâmetros.
  const [searchParams] = useSearchParams();
  const ehnucleoParam = searchParams.get('ehnucleo');
  // Preferência pela query; se ausente, deriva do movimento carregado (núcleo).
  const ehnucleo =
    ehnucleoParam === 'true'
      ? true
      : ehnucleoParam === 'false'
        ? false
        : Boolean(subscription?.nucleo?.id);

  const params = useParams();
  const id = params.id ? Number(params.id) : 0;
  const btnSalvar = id > 0 ? 'Salvar' : 'Cadastrar';
  const defensorid = params.defensorid ? Number(params.defensorid) : 0;
  const mes = params.mes ? params.mes : '';

  // Estados.
  const [modaExcluirShow, setModalExcluirShow] = useState(false);
  const [modalHistorico, setModalHistorico] = useState(false);
  const [loaded, setLoaded] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);

  const [defensorias, setDefensorias] = useState<IOpcao[]>([]);
  const [nucleos, setNucleos] = useState<IOpcao[]>([]);
  const [distritos, setDistritos] = useState<ReadDistritoDto[]>([]);

  // Carrega os selects.
  useEffect(() => {
    Promise.all([
      GetNucleos(0, 1000),
      GetDefensorias(0, 1000),
      readDistrito({ skip: 0, take: 1000 }),
    ])
      .then((results) => {

        results[0].objects.unshift({ id: -1, nome: '(sem núcleo)' } as any);
        setNucleos(
          results[0].objects.map((item) => {
            return { value: item.id, label: item.nome };
          }),
        );


        results[1].objects.unshift({ id: -1, nome: '(sem defensoria)' } as any);
        setDefensorias(
          results[1].objects.map((item) => {
            return { value: item.id, label: item.nome };
          }),
        );

        setDistritos(results[2][0]);
        setLoaded(true);
      })
      .catch((error) => toast.error('Erro ao carregar os dados: ' + error));
  }, []);

  // Carrega a movimentação.
  useEffect(() => {
    if (!loaded)
      return;

    if (id > 0) {
      LerMovimentacao(id)
        .then((result) => {
          if (result) {
            result.data_recebimento = DataIso(result.data_recebimento)
            reset(result);
          }
        })
        .catch((error) => console.error(error));
    } else {
      ReadDefensor(defensorid)
        .then((res) => {
          reset({
            defensor: {
              nome: res?.pessoa?.nome || '',
              id: res?.id || 0,
              data_admissao: res?.data_admissao,
              data_nascimento: res?.pessoa?.dataNascimento,
            } as MovimentacaoReferenceDtoExtended,
            defensoria:
              defensorias.length > 0
                ? {
                  id: defensorias[0].value,
                  nome: defensorias[0].label,
                }
                : undefined,
            nucleo:
              nucleos.length > 0
                ? {
                  id: nucleos[0].value,
                  nome: nucleos[0].label,
                }
                : undefined,
            referencia: DataIso(mes),
          });
        })
        .catch((error) => console.error(error));
    }
  }, [loaded]);

  useEffect(() => {
    if (subscription.defensoria?.id)
      readDistrito({ skip: 0, take: 1000, defensoria_id: subscription.defensoria.id })
        .then((result) => {
          if (result) {
            setDistritos(result[0]);
          }
        })
        .catch((error) => console.error(error));
  }, [subscription.defensoria?.id]);

  const handleRegistros = (lista: MovimentacaoRegistrosDto[]) => {
    setValue('registros', lista);
  };

  const onSubmit: SubmitHandler<UpdateMovimentacaoDto> = (data) => {
    // Obter o ID do distrito do formulário
    const distritoId = getValues('distrito.id') || data.distrito?.id;

    // Transformar os registros para garantir que o tipo está no formato correto { id: number }
    const registrosFormatados = (data.registros || []).map((registro) => ({
      quantidade: registro.quantidade,
      processos: registro.processos,
      tipo: { id: (registro.tipo as any)?.id || registro.tipo?.id },
    }));

    const dt = DataIso(data.referencia as string).substring(0, 7);
    const dr = DataIso(data.data_recebimento as string).substring(0, 10);

    const dados: UpdateMovimentacaoDto = {
      ...(id > 0 ? { id: id } : {}),
      civel: data.civel || false,
      criminal: data.criminal || false,
      data_recebimento: NormalizarData(dr).toISOString(),
      referencia: NormalizarData(dt).toISOString(),
      defensor: { id: data.defensor!.id },
      defensoria: data.defensoria ? { id: data.defensoria.id } : undefined,
      distrito: distritoId ? { id: distritoId } : undefined,
      nucleo: data.nucleo ? { id: data.nucleo.id } : undefined,
      numero_lancamento: data.numero_lancamento,
      observacao: data.observacao,
      pontuar: data.pontuar || false,
      registros: registrosFormatados,
    };

    setIsLoading(true);

    AtualizarMovimentacao(dados)
      .then((res) => {
        localStorage.removeItem(CACHE_MOVIMENTOS);
        toast.success(String(res));
        //navigate(`${Links.Movimentacoes_Index + '/' + dados.defensor?.id + '/' + DataIso(dados.referencia, 'yyyy-MM')}`,);
      })
      .catch((res) => {
        toast.error((res as string) + '');
      })
      .finally(() => setIsLoading(false));
  };

  const handleExcluir = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    setModalExcluirShow(false);
    ExcluirMovimentacao(id)
      .then((res) => {
        toast.success(res + '');
        navigate(
          `${Links.Movimentacoes_Index + '/' + getValues().defensor?.id + '/' + DataIso(getValues().referencia, 'yyyy-MM')}`,
        );
      })
      .catch((res) => {
        toast.error((res as string) + '');
      });
  };

  if (!loaded) return <Loading />;

  return (
    <Fragment>
      <div className="row">
        <div className="col-12">
          <h4>Defensor(a): {getValues().defensor?.nome}</h4>
          <span className="blockquote-footer pb-4 text-end">
            Admissão: {DataAmigavel((getValues().defensor as MovimentacaoReferenceDtoExtended)?.data_admissao)} (
            {TempoAmigavelAteHoje((getValues().defensor as MovimentacaoReferenceDtoExtended)?.data_admissao as unknown as Date)})
            / Idade: {DataAmigavel((getValues().defensor as MovimentacaoReferenceDtoExtended)?.data_nascimento)} (
            {TempoAmigavelAteHoje(
              (getValues().defensor as MovimentacaoReferenceDtoExtended)?.data_nascimento as unknown as Date,
            )}
            ).
          </span>
        </div>
      </div>
      <hr className="pb-4" />

      <Form onSubmit={handleSubmit(onSubmit)} validated={false}>
        <div className="row">
          <div className="mb-3 col-md-3">
            <label htmlFor="referencia" className="form-label">
              Mês Referência:
            </label>
            <input
              id="referencia"
              type="month"
              title="Referência"
              className="form-control"
              required
              value={DataIso(getValues().referencia, 'yyyy-MM') || ''}
              onChange={(e) => {
                setValue('referencia', e.target.value);
              }}
            />
          </div>

          <div className="mb-3 col-md-9">
            <label htmlFor="caixaselecao" className="col-auto form-label me-5">
              {ehnucleo ? 'Núcleo: ' : 'Defensoria: '}
            </label>
            {ehnucleo ? (
              <Select
                id="nucleo"
                options={nucleos}
                value={nucleos.find(
                  (a) => a.value === getValues('nucleo')?.id
                )}
                onChange={(e) => {
                  if (e) {
                    setValue('nucleo', { id: e.value, nome: e.label } as ReadNucleoDto);
                  } else {
                    setValue('nucleo', { id: 0, nome: '' } as ReadNucleoDto);
                  }
                }}
              />

            ) : (
              <Select
                id="defensoria"
                options={defensorias}
                value={
                  defensorias.find(
                    (a) => a.value === getValues()?.defensoria?.id,
                  ) || null
                }
                onChange={(e) => {
                  const defSelecionada = defensorias.find(
                    (a) => a.value === e?.value,
                  );
                  const defensoriaData = {
                    id: defSelecionada?.value,
                    nome: defSelecionada?.label,
                  } as ReadDefensoriaDto;
                  setValue('defensoria', defensoriaData);
                }}
              />
            )}
          </div>

          <div className="mb-3 col-md-3">
            <label htmlFor="data_recebimento" className="form-label">
              Data Recebimento:
            </label>
            <input
              id="data_recebimento"
              type="date"
              title="Data de Recebimento da Informação"
              className="form-control"
              {...register('data_recebimento')}
              required
            />
          </div>

          {!ehnucleo && (
            <div className="mb-3 col-md-7">
              <label htmlFor="distrito" className="form-label">
                Distritos:
              </label>
              <select
                id="distrito"
                className="form-select"
                value={getValues('distrito.id') || ''}
                onChange={(e) => {
                  const distritoId = e.target.value ? Number(e.target.value) : undefined;
                  if (distritoId) {
                    const distritoSelecionado = distritos.find((d) => d.id === distritoId);
                    setValue('distrito', distritoSelecionado ? { id: distritoId, nome: distritoSelecionado.nome } : undefined);
                  } else {
                    setValue('distrito', undefined);
                  }
                }}
              >
                <option value=""></option>
                {distritos && getValues('defensoria.id') &&
                  distritos.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.nome}
                    </option>
                  ))}
              </select>
            </div>
          )}
          <div className="col-md-3">
            <label className="col-auto form-label">Tipo de Registro: </label>
            <div className="row">
              <div className="col-auto form-check ms-3">
                <input
                  id="civel"
                  className="form-check-input"
                  title="Área Cível"
                  type="checkbox"
                  {...register('civel')}
                />
                <label htmlFor="civel" className="form-check-label">
                  Cível
                </label>
              </div>
              <div className="col-auto form-check">
                <input
                  id="criminal"
                  className="form-check-input"
                  title="Área Criminal"
                  type="checkbox"
                  {...register('criminal')}
                />
                <label htmlFor="criminal" className="form-check-label">
                  Criminal
                </label>
              </div>
              {/* <div className="col-auto form-check">
                <input
                  id="pontuar"
                  className="form-check-input"
                  title="Se gera pontuação"
                  type="checkbox"
                  {...register('pontuar')}
                />
                <label htmlFor="pontuar" className="form-check-label">
                  Pontuar
                </label>
              </div> */}
            </div>
          </div>

          <div className="mb-3 col-md-8">
            <label htmlFor="observacao" className="form-label">
              Observação:
            </label>
            <input
              id="observacao"
              title="Observação"
              type="text"
              className="form-control"
              {...register('observacao')}
            />
          </div>

          {false && (
            <div className="mb-3 col-md-2">
              <label
                htmlFor="numero_lancamento"
                className="form-label text-muted"
              >
                Número:
              </label>
              <input
                id="numero_lancamento"
                title="Se é um dado antigo"
                type="number"
                readOnly={true}
                disabled={true}
                className="form-control"
                {...register('numero_lancamento')}
              />
            </div>
          )}
          <div>
            <br />
          </div>
          {loaded && (
            <TabelaRegistros
              updateRegistros={handleRegistros}
              ehnucleo={ehnucleo}
            />
          )}

          <EditadoPorRodape
            dados={{
              editadoPor: getValues().editadoPor,
              editadoEm: getValues().editadoEm,
            }}
          />

          <div>
            <BotoesSalvarExcluir
              isLoading={isLoading}
              texto={btnSalvar}
              textoLoading={btnSalvar === 'Cadastrar' ? ' Cadastrando...' : ' Salvando...'}
              id={id}
              onExcluirClick={() => setModalExcluirShow(true)}
            />
          </div>
        </div>
      </Form>

      <ModalExcluir
        show={modaExcluirShow}
        handleExcluir={handleExcluir}
        handleHide={() => setModalExcluirShow(false)}
      ></ModalExcluir>
      <ModalHistorico
        show={modalHistorico}
        handleHide={() => setModalHistorico(false)}
        tabela={Tabelas.movimentacao}
        idRegistro={id}
      ></ModalHistorico>
    </Fragment>
  );
}
